/* Domain */
import getDomainEnv from '../../domains/utils';
const env = getDomainEnv();

export const colors = env.STYLES.COLORS;